import Common from './common/CommonPowerbook';
import Tmpl from './lineage/Tmpl';


class App{
    constructor(){
        // console.log('constructor Lineage powerbook main');
        this.com = Common.instance;
        this.Tmpl = new Tmpl();
    }

    init(_option) {
        this.com.init(_option);
        this.loadData(_option);
    }

    loadData(_option){
        $.ajax({
            url: this.com.apiUrl(_option.keyword) , dataType: "json", type: "GET",
            success: (_d) => {
                if(_d.code && _d.code === 404 || _d.error || !_d.bodys){
                    location.href = '/lineage/search/v2/powerbook?keyword=' + _option.keyword;
                }else{
                    let contents = this.Tmpl.make(_d);
                    $( _option.container ).html( contents );
                    this.addEvents();
                }
            }
        });
    }

    addEvents(){
        // 목차
        $('#wiki__index__handler').on('click', (e)=>{
            $('#wiki__index__list').toggle();
            $(e.currentTarget).parent().toggleClass('on', $('#wiki__index__list').is(':visible'));
        });

        // 목록보기 몬스터 드롭아이템 레이어 열기
        $('.section-drop-item').on('click', '.drop-item__handler_off',(e)=>{
            $('.drop-item__handler').removeClass('drop-item__handler_on').addClass('drop-item__handler_off');
            $('.drop-item__body').hide();

            let me = $(e.currentTarget).removeClass('drop-item__handler_off').addClass('drop-item__handler_on');
                me.parent().find('> .drop-item__body').show();
            return false;
        });

        // 목록보기 몬스터 드롭아이템 레이어 닫기
        $('.section-drop-item').on('click', '.drop-item__handler_on', (e)=>{
            $(e.currentTarget).removeClass('drop-item__handler_on').addClass('drop-item__handler_off');
            $('.drop-item__body').hide();
            return false;
        });

        // 목록보기 몬스터 드롭아이템 레이어 닫기
        $('.section-drop-item').on('click', '.drop-item__close', (e)=>{
            $('.drop-item__handler').removeClass('drop-item__handler_on').addClass('drop-item__handler_off');
            $('.drop-item__body').hide();
            return false;
        });

        // 제작 총재료 레이어 여닫기
        $('section.object-recipe .object-stuff__handler').on('click', (e)=>{
            let btn = $(e.currentTarget).toggleClass('on');
            btn.parent().find('article.object-stuff').toggle(btn.hasClass('on'));
        });

        // 제작 블릿 트리 여닫기
        $('section.object-recipe .object__itemlist span.bullet').on('click', (e)=>{
            let btn = $(e.currentTarget);
                btn.parent().find('> ul').toggle( btn.hasClass('plus') );
                btn.toggleClass('plus', !btn.hasClass('plus')).toggleClass('minus', !btn.hasClass('minus'));
        });

        // 제작 모든 트리 여닫기
        $('section.object-recipe .object__itemlist .btn-toggle').on('click', (e)=>{
            let btn = $(e.currentTarget);
                btn.toggleClass('on', !btn.hasClass('on')).toggleClass('off', !btn.hasClass('off'));

            $('section.object-recipe .object__itemlist .first-list ul').toggle( btn.hasClass('on') );
            $('section.object-recipe .object__itemlist span.bullet').toggleClass('plus', !btn.hasClass('on'));
            $('section.object-recipe .object__itemlist span.bullet').toggleClass('minus', btn.hasClass('on'));
        });
    }

}

window.powerbookApp = new App();


// WEBPACK FOOTER //
// ./App-lineage.js